/**
 * Rounds a number of 2 decimal places.
 *
 * This is especially useful for currency.
 */
export const roundCurrency = (num: number) =>
  Math.round((num + Number.EPSILON) * 100) / 100
